import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const BillingCycleInput = () => {
  const { billingCycleId = '' } = useParams();
  const decodedId = billingCycleId ? atob(billingCycleId) : billingCycleId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [customers, setCustomers] = useState([]); // State to store customers
  const [frequencies, setFrequencies] = useState([
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Quarterly', label: 'Quarterly' },
    { value: 'Annually', label: 'Annually' },
  ]);
  const [statuses, setStatuses] = useState([
    { value: 'Active', label: 'Active' },
    { value: 'Paused', label: 'Paused' },
    { value: 'Canceled', label: 'Canceled' },
  ]);
  const [newBillingCycleId, setBillingCycleId] = useState(id);
  const route = 'billing_cycle';

  useEffect(() => {
    if (billingCycleId) {
      setIsEditing(true);
      fetchBillingCycleDetails();
    }

    fetchCustomers();
  }, [billingCycleId]);

  const fetchBillingCycleDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.billing_cycle}${id}/`, { headers });
      const billingCycleDetails = response.data;

      setFormData(billingCycleDetails);
    } catch (error) {
      console.error('Error fetching billing cycle details:', error);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customer}`, { headers });
      const customers = response.data;

      const customerOptions = customers.map(customer => ({
        value: customer.id,
        label: customer.name,
      }));

      setCustomers(customerOptions);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    setBillingCycleId(response.id);
  };

  const billingCycleFields = [
    {
      name: 'customer',
      label: 'Customer',
      type: 'select',
      options: customers,
    },
    {
      name: 'start_date',
      label: 'Start Date',
      type: 'date',
    },
   
    {
      name: 'billing_frequency',
      label: 'Billing Frequency',
      type: 'select',
      options: frequencies,
    },
    {
      name: 'next_billing_date',
      label: 'Next Billing Date',
      type: 'date',
    },
   
  ];

  if (id) {
    billingCycleFields.push({
    name: 'status',
    label: 'Status',
    type: 'select',
    options: statuses,
    }, {
    name: 'end_date',
    label: 'End Date',
    type: 'date',
    });
}

  return (
    <div>
      <h1>{isEditing ? 'Edit Billing Cycle' : 'Create Billing Cycle'}</h1>
      <FormComponent
        fields={billingCycleFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default BillingCycleInput;